export default "__VITE_ASSET__BT3dPew1__"